import CloseIcon from "@mui/icons-material/Close";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";

import { getSettlementActionButtonSx, SETTLEMENT_STYLES } from "../../style/styles";

import SettlementExportSectionsList from "./SettlementExportSectionsList";

export default function SettlementExportModal({
  disableExport,
  onClose,
  onExport,
  onToggleSection,
  open,
  sectionOptions,
  selectedSections,
}) {
  return (
    <Dialog fullWidth maxWidth="sm" onClose={onClose} open={open}>
      <DialogTitle sx={SETTLEMENT_STYLES.exportModalHeader}>
        <span style={SETTLEMENT_STYLES.modalTitle}>Export Medical Summary</span>
        <IconButton onClick={onClose} sx={SETTLEMENT_STYLES.exportModalCloseButton}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography className="mb-4" sx={SETTLEMENT_STYLES.modalMetaText}>
          Select the sections you want to include in the PDF.
        </Typography>
        <SettlementExportSectionsList
          onToggle={onToggleSection}
          options={sectionOptions}
          selectedSections={selectedSections}
        />
      </DialogContent>
      <DialogActions className="px-6 pb-5 pt-2">
        <Button
          disabled={disableExport}
          onClick={onExport}
          sx={{
            ...getSettlementActionButtonSx({ disabled: disableExport, isOutlined: false }),
            ...SETTLEMENT_STYLES.exportPrimaryButton,
          }}
        >
          Export
        </Button>
      </DialogActions>
    </Dialog>
  );
}
